import React, {useRef} from "react";
import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import {getManager} from "../../../ts/manager/Manager";
import PostAddEditForm from "./partial/PostAddEditForm";
import {PostType} from "../../../ts/manager/post/PostManager";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import {dispatchRefreshPage} from "../../../ts/event/DispatchEvent";


const PostAddPage = (props:IRouteProps) =>
{
    const formRef = useRef<PostAddEditForm|null>(null);

    const postType:PostType = getManager().navigation.model.routeIDs.post_type ?? "organisation"
    const organisationID = getManager().user.organisationID;

    const getForm = ():PostAddEditForm|null =>
    {
        return (formRef.current as PostAddEditForm) ?? null;
    }

    const onSubmit = () =>
    {
        const postID = getForm()?.choice?.postID ?? null;
        if(!postID){
            return;
        }
        if(postType === "organisation"){
            getManager().user.organisationID = postID;
            getModelFactory().resetFactories();
            dispatchRefreshPage();
        }
    }

    return <>
        <PostAddEditForm
            routeProps={props}
            ref={formRef}
            onSubmit={onSubmit}
            postType={postType}
            organisationID={organisationID}
        />
    </>
}

export default PostAddPage;